import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { PageTitleProps } from "../core/components/pageTitle";
import { Helper } from "../core/util/helper";
import React from "react";
export default class HomeContact extends React.Component<any, any> {
    common = new AppHelper();
    translations: {};
    allocationsGridOptions: {};
    dsMaogrnr: Array<{ Maogrnr: number, Maogruppe: string }> = [];
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled = false;
    isDeleted = false;

    constructor(props) {
        super(props);
        this.common.init(this);
    }


    createInfoText = () => {
        let styleSection: React.CSSProperties = {
            marginBottom: "15px"
        };
        let styleSectionHeader: React.CSSProperties = {
            textDecoration: "underline"
        };
        return (<>
            <section className="contact" style={styleSection }>
                <header style={styleSectionHeader}>
                <h3>{Helper.getTranslation("Adresse.Adresse")}</h3>
                    </header>
                    <p>
                        Innosoft GmbH<br />
                        Martin-Schmeißer-Weg 15<br />
                        D-44227 Dortmund
                    </p>
                </section>
            <section className="contact" style={styleSection}>
                <header style={styleSectionHeader}>
                    <h3>{Helper.getTranslation("Field.Adresse.telefon")}</h3>
                    </header>
                    <p>+49 (0) 231 - 427885-0</p>
                </section>
            <section className="contact" style={styleSection}>
                <header style={styleSectionHeader}>
                    <h3>{Helper.getTranslation("Field.Adresse.fax")}</h3>
                    </header>
                    <p>+49 (0) 231 - 427885-29</p>
                </section>
            <section className="contact" style={styleSection}>
                <header style={styleSectionHeader}>
                        <h3>Support E-Mail</h3>
                    </header>
                    <p><a href="mailto:support@innosoft.de">support@innosoft.de</a></p>
                </section>
            <section className="contact" style={styleSection}>
                <header style={styleSectionHeader}>
                        <h3>Homepage</h3>
                    </header>
                <p><a target="_blank" href="http://www.innosoft.de">http://www.innosoft.de</a></p>
                </section></>)

    }


    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(this.props), { apphelper: this.common});
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.MaschNr,
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};